import { render, staticRenderFns } from "./sendConfig.vue?vue&type=template&id=09bc9e87&scoped=true&"
import script from "./sendConfig.vue?vue&type=script&lang=js&"
export * from "./sendConfig.vue?vue&type=script&lang=js&"
import style0 from "./sendConfig.vue?vue&type=style&index=0&id=09bc9e87&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc9e87",
  null
  
)

export default component.exports